'use client';

import { sendGTMEvent } from '@next/third-parties/google';

export type AidaptiveService = 'search' | 'recommendations';
export type AidaptivePageType = 'search' | 'property' | 'location';
export type AidaptiveEventType = 'impression' | 'click';

export type AidaptiveContext = {
  customerCohort?: string | null;
  service: AidaptiveService;
  pageType: AidaptivePageType;
  /** True when personalized search ran (treatment and control); sets aidaptive_search_user on search load. */
  usedAidaptiveSearch?: boolean;
};

export type AidaptiveEventData = {
  productId: string;
  featuredImageCohort?: string | null;
  service: AidaptiveService;
  eventType: AidaptiveEventType;
  pageType: AidaptivePageType;
  customerCohort?: string | null;
};

export const logAidaptiveCohort = (
  customerCohort: string | null | undefined
) => {
  if (!customerCohort || customerCohort === 'unknown') return;
  sendGTMEvent({
    event: 'set_user_properties',
    user_properties: { aidaptive_cohort: customerCohort },
  });
};

let aidaptiveSearchUserLogged = false;

export const logAidaptiveSearchUser = () => {
  if (aidaptiveSearchUserLogged) return;
  aidaptiveSearchUserLogged = true;
  sendGTMEvent({
    event: 'set_user_properties',
    user_properties: { aidaptive_search_user: 'true' },
  });
};

export const logAidaptiveEvent = (data: AidaptiveEventData) => {
  const eventData: Record<string, string | undefined> = {
    product_id: data.productId,
    service: data.service,
    event_type: data.eventType,
    page_type: data.pageType,
  };

  if (data.featuredImageCohort) {
    eventData.featured_image_cohort = data.featuredImageCohort;
  }
  if (data.customerCohort) {
    eventData.aidaptive_customer_cohort = data.customerCohort;
  }

  sendGTMEvent({ event: 'aidaptive_event', ...eventData });
};
